import React from 'react';
import styled from 'react-emotion';
import { withRouter } from 'react-router-dom';
import t from '@jetshop/intl';

const BackButtonLink = styled.button`
  text-decoration: none;
  color: ${p => p.theme.colors.primary};
  font-weight: bold;
  align-self: flex-start;
  margin: 10px;
  margin-bottom: 40px;
  background: none;
  border: none;
  outline: none;
`;

const BackButton = withRouter(({ history }) => (
  <BackButtonLink onClick={() => history.goBack()}>
    {t('Go back')}
  </BackButtonLink>
));

export default BackButton;
